import { render, staticRenderFns } from "./PushNotificationPreview.vue?vue&type=template&id=24255a48&scoped=true&"
import script from "./PushNotificationPreview.vue?vue&type=script&lang=js&"
export * from "./PushNotificationPreview.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationPreview.vue?vue&type=style&index=0&id=24255a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24255a48",
  null
  
)

export default component.exports